export const USER_INFO_SERVICE_YEARS = ['社会人（4年以下）',
    '社会人（5-10年）',
    '社会人（11年-15年）',
    '社会人（16-20年）',
    '社会人（21年以上）',
    '学生（1年）',
    '学生（2年）',
    '学生（3年）',
    '学生（4年）',
    'その他'];
export const SCHOOL_RESULT_SERVICE_YEARS = ['全学年', '1', '2', '3', '4'];
export default USER_INFO_SERVICE_YEARS;
